import { message } from "antd";
import { Service } from "app/config/service";
import API_ROUTES from "app/constants/routes/api";
import { getItem } from "app/utils/session";
import { GET_DASHBOARD_DETAILS, GET_NOTIFICATION_COUNT, BADGE_API } from "./types";
import { setNotificationCount, setActiveBadgeCount, setCompletedBadgeCount, badgeAPI, setNotificationMessage } from "./action";
import get from "lodash/get";

const { createLogic } = require("redux-logic");

const getNotificationCountLogic = createLogic({
    type: GET_NOTIFICATION_COUNT,
    latest: true,
    process({ action, getState }, dispatch, done) {
        // axios;
        Service({
            method: "post",
            url: API_ROUTES.GET_NOTIFICATION_COUNT,
            data: { authToken: getItem("token") },
        })
            .then((res) => {
                const count = get(res, "data.data.unReadCount", 0);
                dispatch(setNotificationCount(count));

                done();
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }))
                done();
            });
    },
});

const getDashboardLogic = createLogic({
    type: GET_DASHBOARD_DETAILS,
    latest: true,
    process({ action, getState }, dispatch, done) {
        // axios;
        // Service({
        //     method: "post",
        //     url: API_ROUTES.GET_DASHBOARD,
        //     data: { authToken: getItem("token") },
        // })
        //     .then((res) => {
        //         const countDetails = get(res, "data.data", {});
        //         dispatch(setDashboardDetails(countDetails));
        //         done();
        //     })
        //     .catch((err) => {
        //    
                 done();
        //     });
    },
});

const badgeLogic = createLogic({
    type: BADGE_API,
    latest: true,
    process({ action, getState }, dispatch, done) {
        // axios;
        const authToken = getItem("token");
        const payload = {
            authToken: authToken ? authToken : "",
            ...action.payload,
        };
        Service({
            method: "post",
            url: API_ROUTES.BADGE_API,
            data: payload,
        })
            .then((res) => {
                const res1 = get(res, "data.data", {});
                if (payload?.active) {
                    dispatch(setActiveBadgeCount(res1?.jobUnreadCount));
                    dispatch(badgeAPI({ active: false }))
                } else {
                    dispatch(setCompletedBadgeCount(res1?.jobUnreadCount));
                }
                done();
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }))
                done();
            });
    },
});

export default [getNotificationCountLogic, getDashboardLogic, badgeLogic];
